import { all, put, take, takeEvery } from 'redux-saga/effects';

import {
  SUBSCRIPTION_TRIAL_PLAN_START_WITH_SURVEY_SUCCESS,
  USER_AUTHORITY__PERMISSIONS_AND_LIMITS_FETCH_FAILURE,
  USER_AUTHORITY__PERMISSIONS_AND_LIMITS_FETCH_SUCCESS,
} from '@app/store/actionTypes';
import { recordGTMEvent } from '@app/store/analytics/actions';
import {
  fetchUserAuthorityPermissionsAndLimitsFailure,
  fetchUserAuthorityPermissionsAndLimitsSuccess,
} from '@app/store/user/authority/actions';

export function* trackTutorial() {
  type UserAuthorityPermissionAndLimitAction = ReturnType<
    | typeof fetchUserAuthorityPermissionsAndLimitsSuccess
    | typeof fetchUserAuthorityPermissionsAndLimitsFailure
  >;
  const action: UserAuthorityPermissionAndLimitAction = yield take([
    USER_AUTHORITY__PERMISSIONS_AND_LIMITS_FETCH_SUCCESS,
    USER_AUTHORITY__PERMISSIONS_AND_LIMITS_FETCH_FAILURE,
  ]);
  if (action.type === USER_AUTHORITY__PERMISSIONS_AND_LIMITS_FETCH_SUCCESS) {
    yield put(recordGTMEvent('startFirstPlan'));
  }
}

export default function* sagas() {
  yield all([takeEvery(SUBSCRIPTION_TRIAL_PLAN_START_WITH_SURVEY_SUCCESS, trackTutorial)]);
}
